"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrementMinutes = void 0;
var utils_1 = require("@time-input-polyfill/utils");
function decrementMinutes(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, setTime = utils.setTime, use = utils.use;
    describe('Minutes - Decrement', function () {
        it('Should decrement as expected on down key press', function () {
            loadPrimaryInput({ segment: 'minutes' }).then(function () {
                setTime('12:00 AM', 'minutes').then(function () {
                    var a = 59;
                    while (a >= 0) {
                        use.downArrow()
                            .should('have.value', "12:".concat((0, utils_1.toLeadingZero)(a), " AM"))
                            .then(a11yHasExpectedHtml("<p>".concat(a, ".</p>")))
                            .then(hasReturnVal("00:".concat((0, utils_1.toLeadingZero)(a))));
                        a--;
                    }
                    // Testing that it loops back around at the end
                    use.downArrow()
                        .should('have.value', "12:59 AM")
                        .then(a11yHasExpectedHtml("<p>59.</p>"))
                        .then(hasReturnVal("00:59"));
                });
            });
        });
    });
}
exports.decrementMinutes = decrementMinutes;
